import React, {useEffect, useLayoutEffect, useMemo, useState} from 'react'
import {Checkbox, DialogTitle, Divider, FormControl, InputBase, IconButton, List, ListItemText} from "@mui/material";
import {
  DataGridPremium,
  GridColDef, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridSortedRowIdsSelector,GridToolbarContainer, GridValueFormatterParams, useGridApiContext,
  useGridApiRef,
  GridRowOrderChangeParams, GRID_CHECKBOX_SELECTION_COL_DEF, gridFilteredSortedRowEntriesSelector,
} from "@mui/x-data-grid-premium";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import styles from './EventCheckInPage.module.css'
import {EventState, setEvent, useEventState} from "../../slices/eventSlice";
import {useParams} from "react-router";
import {Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Stack} from "@mui/material";
import {ButtonProps} from "@mui/material/Button";
import Button from '@mui/material/Button';
import axios from "axios";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import SearchIcon from "@mui/icons-material/Search";
import Paper from "@mui/material/Paper";
import {styled} from "@mui/material/styles";
import {useAutoEvt} from "../../queries/useAutoEvt";
import {RegisterForm} from "./RegisterForm";
interface Params {
  eventid: string
}

const EventCheckInPage = () => {
  const { eventid } = useParams<Params>()
  useAutoEvt(eventid)

  const apiRef = useGridApiRef();
  const eventState = useEventState()
  const [transactionId, setTransactionId] = useState<number>(0)
  const [rows, setRows] = React.useState([])
  const [isDataLoading, setIsDataLoading] = React.useState(false)
  const [checkboxSelection, setCheckboxSelection] = React.useState([])
  const [searchText, setSearchText] = useState('');
  const [statusList, setStatusList] = React.useState([])
  const [ticketList, setTicketList] = React.useState([])
  const [statusId, setStatusId] = useState('');
  const [ticketId, setTicketId] = useState('');
  const [defaultStatusId, setDefaultStatusId] = useState('');
  const [defaultTicketId, setDefaultTicketId] = useState('');
  const [firstLoad, setFirstLoad] = useState(true);
  const [isFormShowing, setIsFormShowing] = useState(false)
  const [guestId, setGuestId] = useState(null)
  const [invalidateKey, SetinvalidateeKey] = React.useState(1)

  const FloatingButton = styled(Button)<ButtonProps>(({ theme }) => ({
    margin:'auto',
    top: 'auto',
    //  right: '40%',
    bottom: 20,
    left: '25%',
    position: 'fixed',
    width: '50%'
  }))

  useEffect(() => {
    if (!isFormShowing) {
      searchQuery()
    }
  }, [isFormShowing])

  useEffect(() => {
    setFirstLoad(true)
    searchQuery()
  }, [statusId, ticketId])

  useEffect(() => {
    console.log(transactionId)
  }, [transactionId])

  useEffect(() => {
    const timeOutId = setTimeout(() => searchQuery(), 500);
    return () => clearTimeout(timeOutId);
  }, [searchText]);

  const searchQuery = async () => {
    var body = {
      eventid: Number(eventid)
    }
    if (searchText?.length > 0) {
      body['search'] = searchText
    }
    if (Number(statusId) > 0) {
      body['statusid'] = Number(statusId);
    }

    if (Number(ticketId) > 0) {
      body['ticketid'] = Number(ticketId);
    }
    const { data } = await axios.post('/evtattendee', body)
    const parsedData = JSON.parse(data.jsonString)
    console.log(parsedData)


    setDefaultStatusId(parsedData?.selectedstatusid?.toString())
    setDefaultTicketId(parsedData?.selectedticketid?.toString())
    SetinvalidateeKey(invalidateKey+1)

    if (parsedData?.statuslist) {
      setStatusList(parsedData?.statuslist)
    }
    if (parsedData?.ticketlist) {
      setTicketList(parsedData?.ticketlist)
    }

    var selectionValues = []
    selectionValues.push({id: 0, value: false})
    setRows(parsedData.attendeelist.map((item) => {
      selectionValues.push({id: item.id, value: false, ...item})
      return { id: item.id, ...item}
    }))
    // if (firstLoad) {
      setFirstLoad(false)
      setCheckboxSelection(selectionValues)
    // }
  }

  const uploadGuest = async (checkin, id) => {
    setIsDataLoading(true)

    const selection = checkboxSelection.find(cbSels => cbSels.id == id)
    console.log(selection)
    if (selection?.cancheckin) {
      selection.value = checkin
      const allItems = checkboxSelection.filter(itm => itm.id != id)
      console.log(allItems)
      setCheckboxSelection([...allItems, selection])

      const body = {
        'eventid': eventid,
        'id': id,
        'checkin': checkin
      }
      const response = await axios.put(`evtattendee`, body)
      const parsedData = JSON.parse(response.data.jsonString)

      searchQuery()
    }


    setIsDataLoading(false)
  }
  const uploadGuests = async (checkin) => {
    setIsDataLoading(true)
    const selectedItemsIds = checkboxSelection.filter(cbSels => cbSels.value == true).map((item)=> {
      return item.id;
    })

    const body = {
      'eventid': eventid,
      'ids': selectedItemsIds,
      'checkin': checkin
    }
    const response = await axios.put(`evtattendee`, body)
    const parsedData = JSON.parse(response.data.jsonString)

    searchQuery()
    setIsDataLoading(false)
  }

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCheckboxSel(event.target.id, event.target.checked)
  }

  const setCheckboxSel = (id, value) => {
    const selections = checkboxSelection.filter((op) => op.id != id)

    if (id == 0) {
      const gridFilteredRows = gridFilteredSortedRowEntriesSelector(apiRef)
      const selectedItems = gridFilteredRows.filter((gridItem) => (gridItem?.model?.canregister == false && gridItem?.model?.cancheckin == true)).map(listofstuff => {
        return {id: listofstuff.id, value: value}
      })
      setCheckboxSelection([{id: 0, value: value}, ...selectedItems])
    }
    else {
      const selectionValues = [{id: Number(id), value: value}, ...selections].filter((op) => op.id != 0)
      const allValue = shouldAllBeSelected(selectionValues)
      selectionValues.push({id: 0, value: allValue})
      setCheckboxSelection(selectionValues)
    }
  }

  const shouldAllBeSelected = (selections) => {
    var allSelected = true
    selections.forEach(listofstuff => {
      if (listofstuff.value == false) {
        allSelected = false
      }
    })
    return allSelected
  }

  const getCheckboxSel = (id) => {
    const selection = checkboxSelection.find((op) => op.id === id)
    return selection ? selection.value : false
  }

  const handleRegister = (id) => {
    setGuestId(id)
    setIsFormShowing(true)
  }

  var checkboxCol: GridColDef = {
    "field": 'checkedeContactid',
    "headerName":'',
    "type": 'string',
    "headerAlign": 'right',
    "width": 180,
    "align": 'right',
  }
  checkboxCol = GRID_CHECKBOX_SELECTION_COL_DEF
  checkboxCol.field = 'checkedeContactid'
  checkboxCol.headerName = ''
  checkboxCol.width = 160
  checkboxCol.headerAlign = "left"
  checkboxCol.renderHeader = (params) => {
    return (
        <>
          <Grid
              container
              direction="row"
              justifyContent="left"
              alignItems="flex-start"
              // sx={{borderTop: .5, borderLeft: .5, borderRight: .5}}
          >
            <Checkbox
                name={'0'}
                id={'0'}
                checked={getCheckboxSel(0)}
                onChange={handleChange}
                inputProps={{'aria-label': 'controlled'}}
                size="medium"
            />
          </Grid>
        </>
    )
  }
  checkboxCol.renderCell = (params) => {
    if (params.row.canregister) {
      return (
          <>
            {/*{params.row.cancheckin &&*/}
            {/*  <Checkbox*/}
            {/*      name={params.row.id}*/}
            {/*      id={params.row.id}*/}
            {/*      checked={getCheckboxSel(params.row.id)}*/}
            {/*      onChange={handleChange}*/}
            {/*      inputProps={{'aria-label': 'controlled'}}*/}
            {/*      size="medium"*/}
            {/*  />*/}
            {/*}*/}
            {/*<div style={{ width: '50px' }}></div>*/}
            <Button
                variant="contained"
                color="primary"
                onClick={() => {handleRegister(params.row.id)}}
                >
              Register
            </Button>
          </>
      )
    }
    else if(params.row.cancheckin && params.row.checkedin == false) {
      return (
          <>

            <Checkbox
                name={params.row.id}
                id={params.row.id}
                checked={getCheckboxSel(params.row.id)}
                onChange={handleChange}
                disabled={!params.row.cancheckin}
                inputProps={{'aria-label': 'controlled'}}
                size="medium"
            />
            <Button
                variant="contained"
                color="primary"
                disabled={!params.row.cancheckin}
                onClick={() => {uploadGuest(true, params.row.id)}}>
              Check In
            </Button>
          </>
      )
    }
    else {
      return (
          <>
            <Grid
                container
                direction="row"
                justifyContent="left"
                alignItems="flex-start"
            >
              {/*<Checkbox*/}
              {/*    name={params.row.id}*/}
              {/*    id={params.row.id}*/}
              {/*    checked={true}*/}
              {/*    disabled={true}*/}
              {/*    onChange={handleChange}*/}
              {/*    inputProps={{'aria-label': 'controlled'}}*/}
              {/*    size="medium"*/}
              {/*/>*/}
            </Grid>
          </>
      )
    }
  }

  const columns: GridColDef[] = [
    checkboxCol,
    {
      field: 'guestname',
      headerName: 'Guest Name',
      type: 'string',
      width: 300,
    },
    {
      field: 'groupname',
      type: 'string',
      headerName: 'Group Name',
      width: 350
    },
    {
      field: 'purchasername',
      type: 'string',
      headerName: 'Purchaser',
      minWidth: 300
    },
    {
      field: 'checkout-button',
      headerName: '',
      width: 160,
      disableExport: true,
      sortable: false,
      renderCell: (params) => {
        if(params.row.cancheckin == true && params.row.checkedin === true) {
          return <Button
              variant="contained"
              color="primary"
              name={params.row.id + 'checkout'}
              key={params.row.id + 'checkout'}
              onClick={() => {uploadGuest(false, params.row.id)}}>
            UNDO Check In
          </Button>;
        }
      }
    },
    // {
    //   field: 'checkedin',
    //   headerName: 'Checked In',
    //   width: 120,
    //   valueFormatter: (params: GridValueFormatterParams) => {
    //     console.log(params.value)
    //     return params.value == false ? 'NO' : 'yes'
    //   },
    // },
  ]
  const getUnfilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
      gridSortedRowIdsSelector(apiRef);

  function CustomGridToolbar() {
    const apiRef = useGridApiContext();

    const handleExport = (options: GridCsvExportOptions) => {
      options.allColumns = true;
      apiRef.current.exportDataAsCsv(options);
    }

    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };

    return (
        <>
          <GridToolbarContainer >
            <>
              <Grid
                  container
                  direction="row"
                  justifyContent="flex-end"
                  alignItems="center"
                  xs={2} sm={6} md={8}
              >
                <Button
                    {...buttonBaseProps}
                    onClick={() => handleExport({getRowsToExport: getUnfilteredRows})}
                >
                  EXPORT
                </Button>
                {/*<GridToolbarExport style={{color: '#00b2ff'}}/>*/}
              </Grid>
            </>
          </GridToolbarContainer>
        </>
    )
  }

  const getStatusOptions = () => {
    return statusList?.map(item => (
        <MenuItem key={item.statusid} value={item.statusid}>
          {item.status}
        </MenuItem>
    ))
  }

  const handleStatusChange = async (event: SelectChangeEvent) => {
    setStatusId(event.target.value);
  }

  const getTicketItemOptions = () => {
    return ticketList?.map(item => (
        <MenuItem key={item.ticketid} value={item.ticketid}>
          {item.ticketname}
        </MenuItem>
    ))
  }

  const handleTicketChange = async (event: SelectChangeEvent) => {
    setTicketId(event.target.value);
  }

  return (
      <div className={styles.root}>
        <h1>Check In</h1>
        <Paper sx={{borderTop: .5, borderLeft: .5, borderRight: .5}} elevation={1} square={false}>
            {/*<PageContainerToolbar>*/}
              <Stack marginTop={2} direction="row" spacing={1} alignItems="center">
                <FormControl sx={{ m: 1, minWidth: 120, width: 280 }} size="small">
                  <InputLabel id="demo-select-small-label">Select Tickets</InputLabel>
                  <Select
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      label="Select Tickets"
                      key={invalidateKey}
                      defaultValue={defaultTicketId}
                      onChange={handleTicketChange}
                  >
                    {getTicketItemOptions()}
                  </Select>
                </FormControl>

                <FormControl sx={{ m: 1, minWidth: 120, width: 280 }} size="small">
                  <InputLabel id="demo-select-small-label">Status</InputLabel>
                  <Select
                      labelId="demo-select-small-label"
                      key={invalidateKey}
                      id="demo-select-small"
                      label="Status"
                      defaultValue={defaultStatusId}
                      onChange={(event) => { handleStatusChange(event) }}
                  >
                    {getStatusOptions()}
                  </Select>
                </FormControl>
                <Grid container justifyContent="flex-end">
                  <FormControl sx={{ m: 1 }} size="small">
                    <Paper
                        elevation={3}
                        component="form"
                        sx={{ p: '2px 4px', minWidth: 200, display: 'flex', alignItems: 'flex-end', width: 400, height: 36 }}
                    >
                      <InputBase
                          sx={{ ml: 1, flex: 1 }}
                          placeholder=""
                          value={searchText}
                          inputProps={{ 'aria-label': 'Search' }}
                          onKeyPress={(event:any) => {
                            if (event.key === 'Enter') {
                              event.preventDefault()
                              event.stopPropagation()
                              searchQuery()
                            }
                          }}
                          onChange={(event) => {
                            setSearchText(event.target.value)
                          }}
                      />
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                          <SearchIcon />
                        </IconButton>
                    </Paper>
                  </FormControl>
                </Grid>
              </Stack>
          <LoadingBackdrop open={isDataLoading} />
          <RegisterForm isGuestOpen={isFormShowing} setIsGuestOpen={setIsFormShowing} endpoint={'evtattendeeregister'} eventId={eventid} genericid={guestId} />
          <DataGridPremium
            autoHeight
            rows={rows}
            columns={columns}
            apiRef={apiRef}
            components={{
              // Toolbar: CustomGridToolbar,
              // Footer: CustomGridToolbar,
            }}
            componentsProps={{ toolbar: { csvOptions: { allColumns: true }}}}
          />

          <Stack direction="row" spacing={2}>
            <FloatingButton
                variant="contained"
                className={styles.button}
                onClick={() => {uploadGuests(true)}}
                hidden={!checkboxSelection.find((op) => (op.value == true && op.id != 0))}
                color="primary">
              CHECK IN ALL SELECTED GUESTS
            </FloatingButton>
          </Stack>
        </Paper>
    </div>
  )
}

export default EventCheckInPage
